/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable no-restricted-syntax */
import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {useSelector} from 'react-redux'
import {ListItemType} from 'hiya-common/src/reducers/commonTypes'
import {http} from 'hiya-common/src/utils/axios'
import {getGameId} from 'hiya-common/src/utils/helper'
import {getGameBetChip, setGameBetChip} from './constant'
import Style from './style.json'

// 角色信息
export enum RoleEnum {
  普通 = 0,
  房主 = 1,
  管理员 = 2,
}

export enum StatusEnum {
  // 0:下注阶段;1:开奖中阶段;2:开奖结果展示阶段
  bet = 0,
  preparing = 1,
  showRes = 2,
}

export enum resStatusEnum {
  // 0: 未参与本轮;1:赢了;2:输了
  notInvolved = 0,
  win = 1,
  lose = 2,
}
export enum RankTypeEnum {
  // 榜单类型: 1: 日榜;2:周榜;3:月榜
  daily = 1,
  week,
  monthly,
}
export enum GameTypeEnum {
  猜宝箱 = 1,
  greedyHiya = 2,
  tp = 3,
  新转盘 = 4,
  slot = 5,
  greedypro = 6,
}
export enum ActionTypeEnum {
  none = 0, // 无任何交互
  reward = 1, // 领取免单卡弹窗交互
  card = 2, // 有未使用的免单卡弹窗教诲, 对应card_list 字段信息
  entry = 3, // 展示限时回归任务入口，对应jobs_enter字段信息
}
// 主接口
export const greedy_game_homepage = createAsyncThunk(
  'greedy_game_homepage',
  async (arg: any, store: any) => {
    const {deviceinfo, path} = store.getState().env
    const resp = await http.post(
      '/live/game/greedy_game_homepage',
      {
        ...deviceinfo,
        game_id: getGameId(path),
        game_tid: getGameId(path),
        room_id: deviceinfo.h_web_room_id,
        ...arg,
      },
      {
        store,
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)
// 结果接口
export const greedy_game_result = createAsyncThunk(
  'greedy_game_result',
  async (arg: any, store: any) => {
    // 每次获取开奖结果的时候将之前的结果清空
    const {deviceinfo, path} = store.getState().env
    const resp = await http.post(
      '/live/game/greedy_game_result',
      {
        ...deviceinfo,
        game_id: getGameId(path),
        game_tid: getGameId(path),
        room_id: deviceinfo.h_web_room_id,
        ...arg,
      },
      {
        store,
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)
// 下注接口
export const greedy_game_bet = createAsyncThunk(
  'greedy_game_bet',
  async (
    arg: {target_id: number; bet_coins?: number; recommend?: boolean},
    store: any
  ) => {
    const {
      deviceinfo,
      path,
      otherInfo: {from},
    } = store.getState().env
    const resp = await http.post<HiyaRes<any>>(
      '/live/game/greedy_game_bet',
      {
        ...deviceinfo,
        game_id: getGameId(path),
        game_tid: getGameId(path),
        room_id: deviceinfo.h_web_room_id,
        ...arg,
        source: from,
      },
      {
        store,
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)

interface res_type {
  target_id: number
  icon: string
}

export interface round_res_type extends res_type {
  big_reward_flag: boolean
  big_reward_type?: 1 | 2
  round_no?: string
  round_target: number
}
interface food_res_type extends res_type {
  name: string
}
export interface normal_target_res_type {
  target_id: number
  odds: number
  hot_topn: number // 1，2，3有效
  bet_amounts: number
  is_recommended: boolean
}
export interface order_log_list_type {
  round_no: string
  win_num: number
  ct: string
}
interface round_rank_type {
  zy_id: string
  nick_name: string
  icon: string
  coin_nums: number
  rank_no: number
}
export interface loading_conf {
  bg: string
  outerProcess: string
  process: string
  text: string
}
export interface betArea_conf {
  title: string
  chip: string
  chipSelected: string
  result: string
  resultBg: string
  resultBorder: string
  freeColor?: string
  freeBg?: string
}
export interface main_conf {
  targetColor: string
  ruleColor: string
  timeColor: string
  ruleBtnColor: string
}
export interface betRecord_conf {
  bg: string
  titleColor: string
  listBg: string
  coinCountColor: string
  roundColor: string
  dateColor: string
}
export interface gameRank_conf {
  bg: string
  tabBg: string
  tabSelectedBg: string
  tabTextColor: string
  tabTextSelectedColor: string
  ownBg: string
  titleColor: string
  coinCountColor: string
  nameColor: string
  rankColor: string
  ownRankColor: string
  ownNameColor: string
  ownCoinCountColor: string
}

export interface money_conf {
  textColor: string
  divColor: string
}

export interface guide_conf {
  guideBg: string
  bg: string
  text: string
  btnBg: string
  btnText: string
  borderTopColor: string
  borderBottomColor: string
}

export interface result_conf {
  numColor: string
  midColor: string
  timeColor: string
  textColor: string
}

export interface secPage_conf {
  titleColor: string
  bgColor: string
  emptyTextColor?: string
}
export interface history_conf {
  itemBgColor: string
  leftColor: string
  rightColor: string
  leftTitleColor?: string
  leftTimeColor?: string
  cardColor?: string
}
export interface rule_conf {
  titleColor: string
  textColor: string
}

export interface record_conf {
  borderColor: string
  innerBorderColor: string
  evenColor: string
  singelColor: string
  textColor: string
}

export interface rank_conf {
  tabBgColor: string
  tabActColor: string
  tabTextColor: string
  tabActTextColor: string
  nameColor: string
  scoreColor: string
  ownRank: string
  ownName: string
}
interface InitialStateType {
  // 前置工作标记
  hasPreLoadedAct: boolean
  // 加载页面
  isLoading: boolean
  // 主接口内容
  home: {
    // 开奖轮次唯一性ID
    round_no?: string
    // 当前轮次/日
    day_round?: number
    // 金币余额
    coin_num?: number
    // 今日赢钱总数
    today_win?: number
    // 普通食物列表
    normal_targets?: Array<normal_target_res_type>
    // 特殊标的（肉、蔬菜）
    special_targets?: Array<normal_target_res_type>
    // 	当前轮次的状态:0:下注阶段;1:开奖中阶段;2:开奖结果展示阶段
    round_status?: StatusEnum
    // 本轮的中奖标的ID,
    round_target?: number
    // 	当前状态的剩余时间: 秒数
    status_expire?: number
    // 	单次可下注金额列表 -1 代表推荐
    bet_prices?: Array<number>
    // 	历史期号开奖阶段，按开奖期号倒序排列
    history_result?: Array<round_res_type>
    // 主页面数据
    ui_config?: any
    // 图片config 通过ui_config转化获得
    img_ui_config?: any
    // style样式 通过ui_config转化获得
    styleConfig?: {
      loading: loading_conf
      betArea: betArea_conf
      main: main_conf
      guide: guide_conf
      money: money_conf
      result: result_conf
      secPage: secPage_conf
      history: history_conf
      rule: rule_conf
      record: record_conf
      rank: rank_conf
    }
    // 默认下注额度 有下注历史则用上次历史 没有则用这个
    default_bet_price?: number
    // 0 普通 1 房主 2 管理员
    role?: number
    // 选择的下注金额下标
    betChip?: number
    // 命中的target
    hit_target?: number
    // 是否下注过，如果下注过的话就不需要展示手势
    betted?: boolean
    // 每一轮下注上限
    round_bet_limit?: number
    // 免费卡数量
    card_list?: {
      value?: number
      num?: number
    }[]
  }
  // 结果信息
  result_info: {
    // 轮次id
    round_no?: string
    // 赢取的金币数量
    win_coins?: number
    // 本轮下注总金额
    bet_coins?: number
    // 轮次中奖标的ID
    round_target?: number
    //	是否开大奖
    big_reward_flag?: boolean
    // 本轮中奖金额top3
    round_rank?: Array<round_rank_type>
    // 大奖类型:1:蔬菜;2:肉
    big_reward_type?: 1 | 2
    // 本轮的状态:0: 未参与本轮;1:赢了;2:输了
    status?: resStatusEnum
  }
}

const initialState: InitialStateType = {
  hasPreLoadedAct: false,
  isLoading: true, // 默认加载加载页面
  home: {
    status_expire: 30,
  },
  result_info: {},
}

export const GameGreedyMoldSlice = createSlice({
  name: 'GreedyMold',
  initialState,
  reducers: {
    // 加载页面完成
    finishedLoading: (state) => {
      Object.assign(state, {
        ...state,
        isLoading: false,
      })
    },
    // 前置流程标记完成
    finishedPreLoadedAct: (state) => {
      Object.assign(state, {
        hasPreLoadedAct: true,
      })
    },
    // 更改下注
    changeBetChip: (state, action: PayloadAction<number>) => {
      setGameBetChip(action.payload)
      Object.assign(state.home, {
        betChip: action.payload,
      })
    },
    // setHomePage
    setHomePage: (
      state,
      action: PayloadAction<{
        game_tid: number
        status: StatusEnum
        status_expire: number
        hit_target: number
        round_no: string
      }>
    ) => {
      Object.assign(state.home, {
        ...action.payload,
        round_target: action.payload?.hit_target,
        round_status: action.payload?.status,
      })
    },
    // hot_topn 当前轮次下注热榜排名,默认值:0(忽略),大于0才有意义
    updateHotFoods: (
      state,
      action: PayloadAction<{
        game_tid?: number
        target_list: {
          target_id: number
          hot_topn: number
          is_recommended?: boolean
        }[]
      }>
    ) => {
      if (!action.payload?.target_list?.length) {
        return
      }
      const {home} = state
      const {normal_targets} = home
      normal_targets?.forEach((f, fIdx) => {
        const item = action.payload?.target_list?.find(
          (nf) => nf.target_id === f.target_id
        )
        if (item) {
          normal_targets[fIdx].hot_topn = item.hot_topn || 0
          normal_targets[fIdx].is_recommended = item.is_recommended || false
        } else {
          // 如果更新的数组里面没有当前的下注物 就直接将当前的下注物置为不热门即可
          normal_targets[fIdx].hot_topn = 0
          normal_targets[fIdx].is_recommended = false
        }
      })
      Object.assign(state.home, {
        normal_targets,
      })
    },
    // updateCoins
    updateCoins: (
      state,
      action: PayloadAction<{
        mid?: number
        coins?: number
      }>
    ) => {
      Object.assign(state.home, {
        coin_num: action.payload?.coins,
      })
    },
    // 改变金币卡数量
    changeBetCardList: (
      state,
      action: PayloadAction<{
        card_list: {
          value?: number
          num?: number
        }[]
      }>
    ) => {
      Object.assign(state.home, {
        card_list: [...action.payload.card_list],
      })
    },
  },
  extraReducers: (builder) => {
    // 主接口
    builder.addCase(greedy_game_homepage.fulfilled, (state, action) => {
      const {img_ui_config, styleConfig} = state?.home
      const {
        round_status,
        normal_targets,
        ui_config,
        role,
        bet_prices = [],
        default_bet_price,
      } = action.payload
      // 是主播或者房主则bet_prices 增加一个推荐
      const betPrices = bet_prices.slice()
      if (role) {
        betPrices.push(-1)
      }
      // 默认下注额度
      let betChip
      const curChip = getGameBetChip()
      if (betPrices?.some((ite) => ite === curChip)) {
        betChip = curChip
      } else {
        betChip = default_bet_price || bet_prices[0]
        setGameBetChip(default_bet_price)
      }
      // 默认的是否下注 是否的
      let betted = false
      // 只有是下注阶段的时候 才去检查是否有下注
      if (round_status === StatusEnum.bet) {
        betted = normal_targets?.some((f) => f.bet_amounts > 0)
      }
      // 判断配置是不是空对象
      const isSpace = ui_config ? Object.keys(ui_config).length === 0 : true
      Object.assign(state.home, {
        ...action.payload,
        bet_prices: betPrices,
        img_ui_config: isSpace ? img_ui_config : ui_config,
        styleConfig: isSpace
          ? styleConfig
          : JSON.parse(ui_config['style-1.json']),
        betChip,
        betted,
      })
    })
    // 结果接口 用于获取指定结果和其他
    builder.addCase(greedy_game_result.fulfilled, (state, action) => {
      Object.assign(state.result_info, action.payload)
    })
    builder.addCase(greedy_game_bet.fulfilled, (state, action) => {
      const {target_list, coin_num} = action.payload
      // 默认的是否下注 是否的
      let betted = false
      betted = target_list?.some((f) => f.bet_amounts > 0)
      if (target_list?.length) {
        Object.assign(state.home, {
          normal_targets: target_list,
          coin_num,
          betted,
        })
      }
    })
  },
})
export default GameGreedyMoldSlice.reducer
export const useGameGreedyMoldState = () => {
  const data = useSelector((state) => state.Animal_Weasel)
  return data
}
export const GameGreedyMoldActions = GameGreedyMoldSlice.actions
